// ISDP CUSTOM: translated messages for the scaffolder field *validators*. Validators run outside React
// (on Next), so they can't use useTranslationRef; they read the same devsecops namespace through the
// translation API in the apiHolder they are handed. The page has rendered the fields with
// useTranslationRef by then, so the resource is loaded; if not, the key is returned.
import type { ApiHolder } from '@backstage/core-plugin-api';
import { translationApiRef } from '@backstage/core-plugin-api/alpha';
import { devsecopsMessages } from '../../../i18n/devsecops';

export type FieldMessageKey = `fields.${string}`;

export function validatorMessages(apiHolder: ApiHolder): (key: FieldMessageKey) => string {
  try {
    const snapshot = apiHolder.get(translationApiRef)?.getTranslation(devsecopsMessages);
    if (snapshot?.ready) {
      const t = snapshot.t as unknown as (k: string) => string;
      return key => t(key);
    }
  } catch {
    // fall through to keys
  }
  return key => key;
}
